import http from "services/httpService";

export const dumpStorage = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("id");
  localStorage.removeItem("userplan_id");
  localStorage.removeItem("phone");
  localStorage.removeItem("city");
  localStorage.removeItem("source");
  localStorage.removeItem("company_name");
  localStorage.removeItem("industry");
  localStorage.removeItem("range_of_employees");
  localStorage.removeItem("pincode");
  localStorage.removeItem("gstno");
  localStorage.removeItem("primary_contact_name");
  localStorage.removeItem("primary_contact_email");
  localStorage.removeItem("primary_contact_mobile");
  localStorage.removeItem("secondary_contact_name");
  localStorage.removeItem("secondary_contact_email");
  localStorage.removeItem("secondary_contact_mobile");
  localStorage.removeItem("flow");
  localStorage.removeItem("business_type");
  localStorage.removeItem("benefit_type");
  localStorage.removeItem("discount_type");
  localStorage.removeItem("dependent_type");
  localStorage.removeItem("rewards_alloted");
  localStorage.removeItem("sum_insured_gpa");
  localStorage.removeItem("policy");
  localStorage.removeItem("sum_insured");
  localStorage.removeItem("sbo_insurers");
  localStorage.removeItem("employee_collection_required");
  localStorage.removeItem("gmc_company_id");
  localStorage.removeItem("selected_plan_document");
  localStorage.removeItem("uploaded_plan_document");
  localStorage.removeItem("flex");
  localStorage.removeItem("is_product_flex");
  localStorage.removeItem("gmc_business_type");
  sessionStorage.removeItem("userplan_id");
  sessionStorage.removeItem("flex_setup_type");
  localStorage.removeItem("id");
  localStorage.removeItem("gmc_details");
  localStorage.removeItem("company_setup_data");
  localStorage.removeItem("show_buffer_data");
  localStorage.removeItem("show_claim_summary")
};

// fetching selected company information
export const getCompanyInfo = async (businessId, companyName) => {
  try {
    const { data } = await http.get("/phone/get_token/", {
      params: {
        user_id: businessId,
        company_name: companyName,
      },
    });
    return data;
  } catch (err) {
    console.log(err);
    alert("Some error has occured!");
  }
};

// populating local storage based on flow
export const setupInitLocalStorage = (
  flow,
  companyName,
  token,
  businessUserId,
  is_approved,
  flex
) => {
  if (flow) localStorage.setItem("flow", flow);
  localStorage.setItem("is_approved", is_approved);
  localStorage.setItem("company_name", companyName);
  localStorage.setItem("token", token);
  localStorage.setItem("id", businessUserId);
  localStorage.setItem("universal_product", flex);
};
